var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:[
    _vm.$style.wrapper,
    ( _obj = {}, _obj[_vm.$style.isLarge] = _vm.isLarge, _obj[_vm.$style.green] = _vm.appearance === _vm.GREEN, _obj[_vm.$style.primary] = _vm.appearance === _vm.PRIMARY, _obj[_vm.$style.tertiary] = _vm.appearance === _vm.TERTIARY, _obj[_vm.$style.secondary] = _vm.appearance === _vm.SECONDARY, _obj ) ]},[_c('Typography',{attrs:{"variant":"bodySmallRegular"}},[_vm._t("default")],2),(_vm.$slots.rightIcon)?_c('span',{class:_vm.$style.rightIcon},[_vm._t("rightIcon")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }